import React from "react";

const CouponFilters = () => {
    return (
        <div className="coupon-filters">

            <input
                type="text"
                placeholder="Search coupon..."
            />

            <select>
                <option>All Status</option>
                <option>Active</option>
                <option>Inactive</option>
                <option>Expired</option>
                <option>Scheduled</option>
            </select>

            <select>
                <option>All Types</option>
                <option>Percentage</option>
                <option>Flat</option>
                <option>Cashback</option>
                <option>Free Delivery</option>
            </select>

        </div>
    );
};

export default CouponFilters;